import classNames from 'classnames';
import {
  toInteger,
} from 'lodash';
import {
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

function Information({
  className = '',
  name = '',
  size = [0, 0],
  disableInput = false,
  onUpdate = () => {},
}) {
  const sizeWidth = size[0] || '';
  const sizeHeight = size[1] || '';

  /**
   * When a field is changed
   */
  const onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    onUpdate({
      [name]: value,
    });
  };

  /**
   * When either of the size fields are changed
   */
  const onChangeSize = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    // convert the value to a number
    const newSize = toInteger(value);

    if (name === 'sizeWidth') {
      // update the width
      onUpdate({
        size: [
          newSize,
          sizeHeight,
        ],
      });
    } else if (name === 'sizeHeight') {
      // update the height
      onUpdate({
        size: [
          sizeWidth,
          newSize,
        ],
      });
    }
  };

  return (
    <Grid className={classNames('Information', 'resolution', className)} spacing={2} container>
      <Grid size={12}>
        <Field
          type="text"
          label="Name"
          name="name"
          placeholder="Name"
          value={name}
          disabled={disableInput}
          tabIndex={1}
          onChange={onChange}
          autoFocus
          required
        />
      </Grid>

      <Grid size={6}>
        <Field
          type="number"
          label="Width (in pixels)"
          name="sizeWidth"
          value={sizeWidth}
          numberProps={{
            min: 0,
          }}
          tabIndex={2}
          disabled={disableInput}
          onChange={onChangeSize}
          required
        />
      </Grid>

      <Grid size={6}>
        <Field
          type="number"
          label="Height (in pixels)"
          name="sizeHeight"
          value={sizeHeight}
          numberProps={{
            min: 0,
          }}
          tabIndex={2}
          disabled={disableInput}
          onChange={onChangeSize}
          required
        />
      </Grid>
    </Grid>
  );
}

export default Information;
